export default {
  default: () => import("/home/forge/shop.ullmax.com/releases/81023597/layouts/default.vue").then(m => m.default || m)
}